import { Input, TextField } from "@mui/material"


export default function InputStyleField ({ label, value, onHandleStyleChange, type='px' }) {

    const formattedValue = (value_) => {
        return Number(value_.toString().replace(type, ''));
    }

    return (
        <div>
            {/* <label>{label}</label> */}
            <div className="flex">
                <TextField value={formattedValue(value)} onChange={(e)=> onHandleStyleChange(e.target.value+type)} id="outlined-basic" label={label} variant="outlined" />
                    <h2 className="p-2 bg-gray-100 rounded-r-lg ml-2">px</h2>
            </div>
        </div>
    )
};